import { createFileRoute } from '@tanstack/react-router'
import { SubTabsPane } from './-components/dev/transition-playground'

// Delta: a light member of the item pager that hosts its OWN nested tab pager — the two-nested-
// transition-tabs case, inside the stacked screen (see dev-resources.transitions.tsx).
export const Route = createFileRoute('/_app/dev-resources/transitions/one/item/delta')({
  component: () => <SubTabsPane title="Delta" scope="/dev-resources/transitions/one/item/delta" />,
})
